<template lang="pug">

div
    div.fullwidth
        div.title-container
            h1.news-title 404 - route not found
        h4 Valid Routes:
        Sitelink(to='/en/home/')
        Sitelink(to='/en/about')
        Sitelink(to='/en/career')
        Sitelink(to='/en/contact')
        Sitelink(to='/en/company')
        Sitelink(to='/en/impressum')
        Sitelink(to='/en/legaldocumentsandstandards')
        Sitelink(to='/en/news')

        Sitelink(to='/en/products/overview')
        Sitelink(to='/en/products/pdm-600')
        Sitelink(to='/en/products/pdm-600-mobile')
        Sitelink(to='/en/products/pdm-80')
        Sitelink(to='/en/products/signalgenerators/overview')
        Sitelink(to='/en/products/cal-uhf')
        Sitelink(to='/en/products/cal-iec')
        Sitelink(to='/en/products/hfig-600')

        Sitelink(to='/en/products/pdsensors/overview')
        Sitelink(to='/en/products/uhfsensors/overview')
        Sitelink(to='/en/products/uhfsensors/uhf-ps1')
        Sitelink(to='/en/products/uhfsensors/uhf-dvs-50')
        Sitelink(to='/en/products/uhfsensors/uhf-dvs-25')
        Sitelink(to='/en/products/uhfsensors/uhf-ls-50')

        Sitelink(to='/en/products/electricalpdsensors/overview')
        Sitelink(to='/en/products/electricalpdsensors/zm3')
        Sitelink(to='/en/products/electricalpdsensors/bs-pd')
        Sitelink(to='/en/products/electricalpdsensors/hfct-50')

        Sitelink(to='/en/products/otherpdsensors/overview')
        Sitelink(to='/en/products/otherpdsensors/ae-150-m')
        Sitelink(to='/en/products/otherpdsensors/tev-cp')

        Sitelink(to='/en/products/transformerparts/overview')
        Sitelink(to='/en/products/transformerparts/dielectric-window-set')
        Sitelink(to='/en/products/transformerparts/welding-ring-set')

        Sitelink(to='/en/products/pdaccessories/overview')
        Sitelink(to='/en/products/pdaccessories/sensorcase')
        Sitelink(to='/en/products/pdaccessories/flangeadapters')
        Sitelink(to='/en/products/pdaccessories/calibratorcase')
        Sitelink(to='/en/products/pdaccessories/cal-uhf-accessory-kit')

        Sitelink(to='/en/services/overview')
        Sitelink(to='/en/services/diagnostic-measurements')
        Sitelink(to='/en/services/hv-consulting')
        Sitelink(to='/en/services/custom-devices')

        Sitelink(to='/de/home')
        Sitelink(to='/de/about')
        Sitelink(to='/de/career')
        Sitelink(to='/de/contact')
        Sitelink(to='/de/company')
        Sitelink(to='/de/impressum')
        Sitelink(to='/de/legaldocumentsandstandards')
        Sitelink(to='/de/news')

        Sitelink(to='/de/products/overview')
        Sitelink(to='/de/products/partial-discharge-monitoring-systems/overview')
        Sitelink(to='/de/products/pdm-600')
        Sitelink(to='/de/products/pdm-600-mobile')
        Sitelink(to='/de/products/pdm-80')
        Sitelink(to='/de/products/signalgenerators/overview')
        Sitelink(to='/de/products/cal-uhf')
        Sitelink(to='/de/products/cal-iec')
        Sitelink(to='/de/products/hfig-600')

        Sitelink(to='/de/products/pdsensors/overview')
        Sitelink(to='/de/products/uhfsensors/overview')
        Sitelink(to='/de/products/uhfsensors/uhf-ps1')
        Sitelink(to='/de/products/uhfsensors/uhf-dvs-50')
        Sitelink(to='/de/products/uhfsensors/uhf-dvs-25')
        Sitelink(to='/de/products/uhfsensors/uhf-ls-50')

        Sitelink(to='/de/products/electricalpdsensors/overview')
        Sitelink(to='/de/products/electricalpdsensors/zm3')
        Sitelink(to='/de/products/electricalpdsensors/bs-pd')
        Sitelink(to='/de/products/electricalpdsensors/hfct-50')

        Sitelink(to='/de/products/otherpdsensors/overview')
        Sitelink(to='/de/products/otherpdsensors/ae-150-m')
        Sitelink(to='/de/products/otherpdsensors/tev-cp')

        Sitelink(to='/de/products/transformerparts/overview')
        Sitelink(to='/de/products/transformerparts/dielectric-window-set')
        Sitelink(to='/de/products/transformerparts/welding-ring-set')

        Sitelink(to='/de/products/pdaccessories/overview')
        Sitelink(to='/de/products/pdaccessories/sensorcase')
        Sitelink(to='/de/products/pdaccessories/flangeadapters')
        Sitelink(to='/de/products/pdaccessories/calibratorcase')
        Sitelink(to='/de/products/pdaccessories/cal-uhf-accessory-kit')

        Sitelink(to='/de/services/overview')
        Sitelink(to='/de/services/diagnostic-measurements')
        Sitelink(to='/de/services/hv-consulting')
        Sitelink(to='/de/services/custom-devices')

</template>

<script>
export default {
    meta: {
        de: {
            title: "BSS 404 ",
            description: "404 page - This URL does not exist",
        },
        en: {
            title: "BSS 404",
            description: "404 page - This URL does not exist",
        },
    },
    mounted() {
        // Set a <meta name=”robots” content=”noindex”> metatag in head,
        // so that Google does not index any page that lead here
        // Basically a more convoluted alternative to a 'real' server 404,
        // but we can show some content
        document.head.querySelector("meta[name='robots']").content = "noindex";
    },
};
</script>

<style lang="sass" scoped>
.title-container
    display: flex
    justify-content: center
    h1
        margin-top: 0
        font-size: 3em
        font-weight: 200
a
    margin-bottom: 0
</style>